import {
    getModule,
    Module,
    Mutation,
    Action,
    VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import * as api from '@/store/api';
import {Version} from '@/store/models';

@Module({
    namespaced: true,
    name: 'version',
    store,
    dynamic: true,
})
class VersionModule extends VuexModule {
    version: Version | null = null;
    outOfDate: boolean = false;

    @Action
    public async getVersion() {
        this.setVersion(await api.getVersion());
    }

    @Mutation
    setVersion(version: Version | null) {
        if (version !== null && this.version !== null
            && (version.Version !== this.version.Version || version.BuildDate !== this.version.BuildDate)) {
            this.outOfDate = true;
        }
        if (version !== null) {
            this.version = version;
        }
    }

}

export default getModule(VersionModule);
